// Models
import { QueueType } from 'app/modules/queues/models';

import {
  CreateQueuePayload,
  EditQueuePayload,
  RetrieveQueueListPayload,
  ValidateAgentInQueuePayload,
} from 'app/modules/queues/requests';
import {
  GetArticleCountResponse,
  QueueDetailsResponse,
  RetrieveQueuesListResponse,
  GetDeadlineSummaryResponse,
  ValidateAgentInQueueResponse,
} from 'app/modules/queues/responses';

// Utils
import { destroy, get, post, put } from 'app/shared/utils/fetchr';

export const listQueuesApi = (
  payload: RetrieveQueueListPayload,
): Promise<RetrieveQueuesListResponse> => {
  return post('/v1/queues/list', payload, [
    { key: 'type', value: payload.type },
  ]);
};

export const retrieveQueueApi = (
  queueId: string,
): Promise<QueueDetailsResponse> => {
  return get('/v1/queue/:id'.replace(':id', queueId));
};

export const retrieveQueuedArticlesCountApi = (
  payload: QueueType,
): Promise<GetArticleCountResponse> => {
  return get('/v1/queues/articles-count', [{ key: 'type', value: payload }]);
};

export const createQueueApi = (
  payload: CreateQueuePayload,
): Promise<QueueDetailsResponse> => {
  return post('/v1/queue', payload, [{ key: 'type', value: payload.type }]);
};

export const editQueueApi = (
  payload: EditQueuePayload,
): Promise<QueueDetailsResponse> => {
  return put('/v1/queue', payload);
};

export const deleteQueueApi = (
  queueId: number,
): Promise<QueueDetailsResponse> => {
  return destroy('/v1/queue/:id'.replace(':id', String(queueId)));
};

export const getDeadlineSummaryApi = (
  queueType: QueueType,
): Promise<GetDeadlineSummaryResponse> => {
  return get('/v1/queues/deadline-summary', [
    { key: 'type', value: queueType },
  ]);
};

export const validateAgentInQueueApi = (
  payload: ValidateAgentInQueuePayload,
): Promise<ValidateAgentInQueueResponse> => {
  return post('/v1/queues/validate-agent-in-queue', payload);
};
